import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import Information from '../components/modals/common/Information';
import {
  FormDropdownRadio,
  FormDropdownClearButton,
} from '../components/CommonFormComponents';

import {
  USER_ROLES,
  HEADER_CONSTANTS,
  WORK_HOUR_ZONES,
  FILE_CODE,
  REPORT_WORK_HOUR_ZONE,
  API_FLAG,
  REQUEST_PARAMS,
  CHECKBOX,
  USER_ROLES_IDS,
  STATUS_CODE,
  WEEK_INTERVAL_REPORT_IDS,
  MACHINERY_TYPES_REPORT,
  REPORT_KEY_PLAN_REFLECT_FLAG,
} from '../utilities/constants';

import { ReportSettingService } from '../services/ReportSettings';
import { FieldService } from '../services/Fields';
import { FieldApprovalsService } from '../services/FieldApprovals';
import { PrintService } from '../services/Prints'; // 帳票API
import LocalStorageService from '../services/utilities/LocalStorageService';
import PrintUtility from '../utilities/printUtility';
import { FieldItemInputService } from '../services/FieldItemInputs';
import { blobToJsonConversion } from '../utilities/commonUtil';
import ReportNames from '../utilities/reportNames';
import ReportDisplayOptions from '../utilities/reportDisplayOptions';
import {
  isPrimaryCompanyRoleId,
  isTargetRoleId,
} from '../utilities/roleUtility';
import RoleUtility from '../utilities/roleUtility';
import { messageUtility } from '../utilities/messageUtility';
import DocumentDelegate from '../utilities/DocumentDelegate';
import { DropdownCalendarLoader } from '../utilities/formComponents';
import DropdownSelector from '../components/dropdowns/DropdownSelector';
import SessionStorageService from '../services/utilities/SessionStorageService';
import FieldGroupService from '../services/FieldGroups';

import Helmet from 'react-helmet';
import { ConferencePageHeader } from '../components/PageHeader';
export const ReportLists = [
  {
    id: 1,
    name: ReportNames.WorkAndDiary,
  },
  {
    id: 2,
    name: ReportNames.Adjust,
  },
  {
    id: 3,
    name: ReportNames.Diary,
  },
  {
    id: 4,
    name: ReportNames.AllKYWork,
  },
  {
    id: 5,
    name: ReportNames.AllAdjustWork,
  },
  {
    id: 6,
    name: ReportNames.AllResultWork,
  },
  {
    id: 7,
    name: ReportNames.AllKY,
  },
  {
    id: 8,
    name: ReportNames.GatePassageDaily,
  },
  {
    id: 9,
    name: ReportNames.GatePassageWeekly,
  },
  {
    id: 10,
    name: ReportNames.AllCraneUse,
  },
  {
    id: 11,
    name: ReportNames.CraneUseDaily,
  },
  {
    id: 12,
    name: ReportNames.CraneUseWeekly,
  },
  {
    id: 13,
    name: ReportNames.AllMachineryInstruction,
  },
  {
    id: 14,
    name: ReportNames.MachineryUse,
  },
  {
    id: 15,
    name: ReportNames.HotWorkManager,
  },
  {
    id: 16,
    name: ReportNames.HotWork,
  },
  {
    id: 17,
    name: ReportNames.AllOxygenLackPartnerCompany,
  },
  {
    id: 18,
    name: ReportNames.EarlytimeWork,
  },
  {
    id: 19,
    name: ReportNames.OvertimeWork,
  },
  {
    id: 20,
    name: ReportNames.EarlytimeNotify,
  },
  {
    id: 21,
    name: ReportNames.OvertimeNotify,
  },
  {
    id: 22,
    name: ReportNames.AllFixedWorkDetailedStatementPayment,
  },
  {
    id: 23,
    name: ReportNames.AllUnfixedWorkDetailedStatementPayment,
  },
  {
    id: 24,
    name: ReportNames.AllWorkDetailedStatementPayment,
  },
  {
    id: 25,
    name: ReportNames.FixedWorkTotal,
  },
  {
    id: 26,
    name: ReportNames.UnfixedWorkTotal,
  },
  {
    id: 27,
    name: ReportNames.WorkTotal,
  },
  {
    id: 28,
    name: ReportNames.GatePassageMonthly,
  },
  {
    id: 29,
    name: ReportNames.CraneUseMonthly,
  },
  {
    id: 30,
    name: ReportNames.MonthWork,
  },
  {
    id: 35,
    name: ReportNames.AllNishimatsuKy,
  },
  {
    id: 36,
    name: ReportNames.NishimatsuKNisshi,
  },
  {
    id: 37,
    name: ReportNames.CstmGoyoField,
  },
  {
    id: 38,
    name: ReportNames.CstmGoyo,
  },
  {
    id: 39,
    name: ReportNames.KyGoyo,
  },
  {
    id: 40,
    name: ReportNames.CraneGoyo,
  },
  {
    id: 41,
    name: ReportNames.HighplaceGoyo,
  },
  {
    id: 42,
    name: ReportNames.VehicleGoyo,
  },
  {
    id: 43,
    name: ReportNames.FireworkGoyo,
  },
  {
    id: 44,
    name: ReportNames.MatsuiSafety,
  },
  {
    id: 45,
    name: ReportNames.TaiseiSafety,
  },
  {
    id: 46,
    name: ReportNames.SeibuWorkCommon,
  },
  {
    id: 47,
    name: ReportNames.SeibuWorkRail,
  },
  {
    id: 48,
    name: ReportNames.SeibuSafety,
  },
  {
    id: 49,
    name: ReportNames.KSagyoyotei,
  },
  {
    id: 50,
    name: ReportNames.KNisshi,
  },
  {
    id: 51,
    name: ReportNames.KJisshi,
  },
  {
    id: 52,
    name: ReportNames.CstmObayashiAllAdjustWork,
  },
  {
    id: 53,
    name: ReportNames.CstmObayashiAllResultWork,
  },
  {
    id: 54,
    name: ReportNames.CstmObayashiWorkSafety,
  },
  {
    id: 55,
    name: ReportNames.KKosuseiri,
  },
  {
    id: 56,
    name: ReportNames.Saigaitok,
  },
  {
    id: 57,
    name: ReportNames.Nisshi,
  },
  {
    id: 83,
    name: ReportNames.Shiji,
  },
  {
    id: 84,
    name: ReportNames.Ky,
  },
  {
    id: 85,
    name: ReportNames.Anzenshiji,
  },
  {
    id: 86,
    name: ReportNames.Shinchoku,
  },
  {
    id: 87,
    name: ReportNames.NishimatsuDNisshi,
  },
  {
    id: 88,
    name: ReportNames.Takuma,
  },
  {
    id: 89,
    name: ReportNames.TaiseiSafety2,
  },
  {
    id: 90,
    name: ReportNames.SeibuWorkCommonPart2,
  },
  {
    id: 91,
    name: ReportNames.SeibuWorkRailPart2,
  },
  {
    id: 92,
    name: ReportNames.SeibuSafety2,
  },
  {
    id: 93,
    name: ReportNames.SeibuSafety3,
  },
  {
    id: 94,
    name: ReportNames.Geppo,
  },
  {
    id: 95,
    name: ReportNames.OkumuraUchiawase,
  },
  {
    id: 96,
    name: ReportNames.OkumuraNisshi,
  },
  {
    id: 97,
    name: ReportNames.Ky1,
  },
  {
    id: 98,
    name: ReportNames.TakenakadobokuNisshi,
  },
  {
    id: 99,
    name: ReportNames.TakenakadobokuKy,
  },
  {
    id: 100,
    name: ReportNames.Tachiai,
  },
  {
    id: 101,
    name: ReportNames.ToutetsuNisshiJR,
  },
  {
    id: 102,
    name: ReportNames.ToutetsuKyJR,
  },
  {
    id: 103,
    name: ReportNames.NakayamaNisshi,
  },
  {
    id: 104,
    name: ReportNames.NakayamaKy,
  },
  {
    id: 105,
    name: ReportNames.MitsuisumitomoNissi,
  },
  {
    id: 106,
    name: ReportNames.ZenitakaMeeting,
  },
  {
    id: 107,
    name: ReportNames.ZenitakaAnzen,
  },
  {
    id: 108,
    name: ReportNames.KumagaiUchiawase,
  },
  {
    id: 110,
    name: ReportNames.Uchiawase,
  },
  {
    id: 111,
    name: ReportNames.UchiawaseshoNippo,
  },
  {
    id: 112,
    name: ReportNames.Nippo,
  },
  {
    id: 113,
    name: ReportNames.ShijiNisshi,
  },
  {
    id: 114,
    name: ReportNames.ShijiKy,
  },
  {
    id: 115,
    name: ReportNames.KawaguchiNisshi,
  },
  {
    id: 116,
    name: ReportNames.ObayashiAllAdjustWork,
  },
  {
    id: 117,
    name: ReportNames.ObayashiAllResultWork,
  },
  {
    id: 119,
    name: ReportNames.WorkAndDiary2,
  },
  {
    id: 120,
    name: ReportNames.HpsNisshiL,
  },
  {
    id: 121,
    name: ReportNames.HpsNisshiS,
  },
  {
    id: 122,
    name: ReportNames.HpsKyL,
  },
  {
    id: 123,
    name: ReportNames.HpsKyS,
  },
  {
    id: 124,
    name: ReportNames.NkkTowerCraneMeetingForm,
    hideExcelButtonForPartner: true,
  },
  {
    id: 125,
    name: ReportNames.NkkTransportableCraneMeetingForm,
    hideExcelButtonForPartner: true,
  },
  {
    id: 126,
    name: ReportNames.NkkVehicleMachineryMeetingForm,
    hideExcelButtonForPartner: true,
  },
  {
    id: 127,
    name: ReportNames.KgtNisshi,
  },
  {
    id: 134,
    name: ReportNames.TakenakadobokuNisshiBasho,
  },
  {
    id: 135,
    name: ReportNames.KtkNippo,
  },
  {
    id: 136,
    name: ReportNames.UkgNisshi,
  },
  {
    id: 137,
    name: ReportNames.TouyouKy,
  },
  {
    id: 138,
    name: ReportNames.TouyouNisshi,
  },
  {
    id: 139,
    name: ReportNames.NakanofudouKy,
  },
  {
    id: 140,
    name: ReportNames.Cr576KyoritsuNisshi,
  },
  {
    id: 141,
    name: ReportNames.Cr577KyoritsuRaky,
  },
  {
    id: 142,
    name: ReportNames.Cr578KonoikeA,
  },
  {
    id: 143,
    name: ReportNames.Cr579KonoikeB,
  },
  {
    id: 144,
    name: ReportNames.Cr136WorkAndDiary2,
  },
  {
    id: 145,
    name: ReportNames.Cr660KumagaiUchiawase,
  },
  {
    id: 146,
    name: ReportNames.Cr680CstmGoyoD,
  },
  {
    id: 147,
    name: ReportNames.Cr681CstmGoyoK,
  },
  {
    id: 148,
    name: ReportNames.Cr682CivilKy,
  },
  {
    id: 149,
    name: ReportNames.Cr683CivilNisshi,
  },
  {
    id: 150,
    name: ReportNames.Cr684ToutetsuNisshi,
  },
  {
    id: 151,
    name: ReportNames.Cr685ToutetsuKy,
  },
  {
    id: 152,
    name: ReportNames.Cr686HonmagumiNisshi,
  },
  {
    id: 153,
    name: ReportNames.Cr687HonmagumiNisshiMeeting,
  },
  {
    id: 154,
    name: ReportNames.Cr688FkdNisshiK,
  },
  {
    id: 155,
    name: ReportNames.Cr689FkdKyK,
  },
  {
    id: 156,
    name: ReportNames.Cr690TekkenKy,
  },
  {
    id: 158,
    name: ReportNames.Cr692UkgAllWork,
  },
  {
    id: 159,
    name: ReportNames.Cr693NishimatsuWorkAndDiary,
  },
  {
    id: 160,
    name: ReportNames.Cr694TokyuWorkAndDiary,
  },
  {
    id: 161,
    name: ReportNames.Cr695TouyouNisshiD,
  },
  {
    id: 162,
    name: ReportNames.Cr629AndouhazamaNisshi,
  },
  {
    id: 163,
    name: ReportNames.Cr630AndouhazamaKyPonchie,
  },
  {
    id: 164,
    name: ReportNames.Cr696DainihondobokuWorkAndDiary,
  },
  {
    id: 165,
    name: ReportNames.Cr697DainihondobokuAllKyWork,
  },
  {
    id: 166,
    name: ReportNames.Cr598GoudakoumutenToukyoAnzenshiji,
  },
  {
    id: 167,
    name: ReportNames.Cr599GoudakoumutenToukyoShinchoku,
  },
  {
    id: 168,
    name: ReportNames.Cr800AsanumaWorkAndDiary,
  },
  {
    id: 169,
    name: ReportNames.Cr801KoseikensetsuWorkAndDiary,
  },
  {
    id: 170,
    name: ReportNames.Cr802TouakensetsuWorkAndDiary,
  },
  {
    id: 171,
    name: ReportNames.Cr803TaiseiSafety,
  },
  {
    id: 172,
    name: ReportNames.Cr804TaiseiSafety2,
  },
  {
    id: 173,
    name: ReportNames.Cr805TobishimaKy,
  },
  {
    id: 174,
    name: ReportNames.Cr806TokyuTetsudouDobokuWorkAndDiary,
  },
  {
    id: 175,
    name: ReportNames.Cr807KumagaiAllKycWork,
  },
  {
    id: 176,
    name: ReportNames.Cr808FudotetraWorkAndDiary,
  },
  {
    id: 177,
    name: ReportNames.Cr809FudotetraAllKyWork,
  },
  {
    id: 178,
    name: ReportNames.Cr810TodadouroWorkAndDiary
  },
  {
    id: 179,
    name: ReportNames.Cr811TaiseiSafety3,
  },
  {
    id: 180,
    name: ReportNames.Cr812TaiseiKy,
  },
  {
    id: 181,
    name: ReportNames.Cr813TokyuCnstKy,
  },
  {
    id: 182,
    name: ReportNames.Cr814TaikiAllKyWork,
  },
  {
    id: 183,
    name: ReportNames.Cr815KgKenchikuWorkAndDiary,
  },
  {
    id: 184,
    name: ReportNames.Cr316MitsuisumitomoNissiBashonashi,
  },
  {
    id: 185,
    name: ReportNames.CR317SeibuWorkCommonPart3,
  },
  {
    id: 186,
    name: ReportNames.Cr818TekkenWorkAndDiary,
  },
  {
    id: 187,
    name: ReportNames.Cr819AndouhazamaKyMinisagyoTejyunsho,
  },
  {
    id: 188,
    name: ReportNames.Cr820AndouhazamaKyUramenNashi,
  },
  {
    id: 189,
    name: ReportNames.Cr821AndouhazamaKySetsumeisho,
  },
  {
    id: 190,
    name: ReportNames.Cr822MorigumiWorkAndDiary,
  },
  {
    id: 191,
    name: ReportNames.Cr823KajitaWorkAndDiary,
  },
  {
    id: 192,
    name: ReportNames.Cr824WorkSafeDiaryPs,
  },
  {
    id: 193,
    name: ReportNames.Cr825KyReportPs,
  },
  {
    id: 194,
    name: ReportNames.Cr826Renrakuchouseikiroku,
  },
  {
    id: 195,
    name: ReportNames.Cr827KYTetsudo,
  },
  {
    id: 196,
    name: ReportNames.Cr828MaruhongumiSagyouUchiawase,
  },
  {
    id: 197,
    name: ReportNames.Cr829SatokogyoWorkAndDiary,
  },
  {
    id: 198,
    name: ReportNames.Cr830MeikoWorkAndDiary,
  },
  {
    id: 199,
    name: ReportNames.Cr831MeikoAllKyWork,
  },
  {
    id: 200,
    name: ReportNames.Cr832KajitaCraneMachineUse,
  },
  {
    id: 201,
    name: ReportNames.Cr833KajitaTowercraneUse,
  },
  {
    id: 202,
    name: ReportNames.Cr834WorkAndDiary,
  },
  {
    id: 203,
    name: ReportNames.Cr835AllKyWork,
  },
  {
    id: 204,
    name: ReportNames.Cr138SignlessWorkAndDiary,
  },
  {
    id: 205,
    name: ReportNames.Cr336SeibuWorkRailPart3,
  },
  {
    id: 206,
    name: ReportNames.Cr837AllKyWork,
  },
  {
    id: 207,
    name: ReportNames.Cr838AndouhazamaAllCraneUse,
  },
  {
    id: 208,
    name: ReportNames.Cr839AndouhazamaMachineryInstruction,
  },
  {
    id: 209,
    name: ReportNames.Cr840WorkAndDiary,
  },
  {
    id: 210,
    name: ReportNames.Cr841KgDobokuWorkAndDiary2,
  },
  {
    id: 211,
    name: ReportNames.Cr842WorkAndDiary,
  },
  {
    id: 212,
    name: ReportNames.Cr843AllKyWork,
  },
  {
    id: 213,
    name: ReportNames.Cr844SafetyAndDiary,
  },
];

export default class ReportSettings extends React.Component {
  constructor(props) {
    super(props);

    // 月次帳票を選択できるのは元請ユーザのみ
    this.isEnableMonthlyReport = isTargetRoleId(USER_ROLES_IDS.PRIME_COMPANY);
    const defaultUnitCode = 1; // 日次

    let machineryTypesReport = [];
    _.map(MACHINERY_TYPES_REPORT, type => {
      let items = { id: type.id, name: type.name };
      machineryTypesReport.push(items);
    });

    this.state = {
      roleId: LocalStorageService.getRoleId(),
      fieldId: sessionStorage.getItem('field_id'),
      fieldStartDay: 0,
      workHourZone: sessionStorage.getItem('work_hour_zone'),
      targetDate: sessionStorage.getItem('date_from'),
      reportSettings: [],
      settingId: null,
      settingReportName: null,
      // SessionStorageから取得しているのは日付変更でも月次への変更を維持するため
      unitCode: this.isEnableMonthlyReport
        ? SessionStorageService.getReportUnitCode() || defaultUnitCode
        : defaultUnitCode,
      outputSetting: {},
      settingParam: {},
      itemNames: [],
      errors: {},
      hasFilter: 0,
      apiMessage: null, // APIレスポンスメッセージ
      visibleDialogFlag: null, // 開閉用ダイアログフラグ
      machineryTypesReport,
    };

    this.excelOutput = false; // excel出力状態
    this.pdfOutput = false; // pdf出力状態

    this.defaultSettingParam = {
      a_item_id: '',
      b_item_id: '',
      c_item_id: '',
      d_item_id: '',
      field_tree_id: '',
      foreman_user_id: '',
      category_code: '',
      start_date: '',
      end_date: '',
      gate_id: '',
      crane_id: '',
      machinery_id: '',
      machinery_type: '',
      is_partnerLv1_print: '',
      approval_flag: '',
      time_zone: REPORT_WORK_HOUR_ZONE.specific.id,
      key_plan_reflect_flag: REPORT_KEY_PLAN_REFLECT_FLAG.reflect.id,
    };

    this.checkFilter = this.checkFilter.bind();

    this.events = {
      sidebar: {
        outputSetting: this.outputSetting.bind(this),
      },
      header: {
        changeUnitCode: this.changeUnitCode.bind(this),
      },
      setting: {
        checkStartAndEndDates: this.checkStartAndEndDates.bind(this),
        setParam: this.setParam.bind(this),
        setCheckParam: this.setCheckParam.bind(this),
        setRadioParam: this.setRadioParam.bind(this),
        setDropdown: this.setDropdown.bind(this),
        setForemanDropdown: this.setForemanDropdown,
        clearParam: this.clearParam.bind(this),
        outputExcel: this.outputExcel.bind(this),
        outputPdf: this.outputPdf.bind(this),
      },
    };
  }

  componentDidMount() {
    this.setReportSettings(this.state.unitCode);
    this.getItemListTitle();
  }

  componentDidUpdate() {
    DocumentDelegate.init();
    this.FormCalendar = new DropdownCalendarLoader();
    this.FormCalendar.constructerQuery = '.sys-form-calender';
    this.FormCalendar.init(DocumentDelegate, (e, name, value) => {
      const settingParam = this.state.settingParam;
      settingParam[name] = value;
      let reportSetting = this.state.outputSetting.report_setting;
      if (
        reportSetting.specifying_period_display_flag &&
        (name === 'start_date' || name === 'end_date')
      ) {
        this.checkStartAndEndDates();
      }
      this.setState({ settingParam });
    });
  }

  componentWillUnmount() {
    SessionStorageService.removeReportUnitCode();
  }

  setReportSettings(unitCode) {
    const fieldId = this.state.fieldId;
    const param = {
      field_id: fieldId,
      unit_code: unitCode,
    };
    ReportSettingService.list(param).then(resp => {
      if (resp.result) {
        const reportSettings = resp.data.entities.report_settings;
        const sorted = _.orderBy(
          reportSettings,
          ['order_number', 'id'],
          ['asc', 'asc']
        );
        this.setState({
          settingId: null,
          settingReportName: null,
          reportSettings: sorted,
        });
      }
    });
    FieldService.info(fieldId).then(resp => {
      if (resp.result) {
        this.setState({
          fieldStartDay: resp.data.entities.field.start_day,
        });
      }
    });
  }

  checkFilter(data) {
    return (
      data.crane_display_flag === 1 ||
      data.field_item_list1_display_flag === 1 ||
      data.field_item_list2_display_flag === 1 ||
      data.field_item_list3_display_flag === 1 ||
      data.field_item_list4_display_flag === 1 ||
      data.foreman_user_display_flag === 1 ||
      data.gate_display_flag === 1 ||
      data.key_plan_display_flag === 1 ||
      data.machinery_display_flag === 1 ||
      data.partner_company_1_unit_display_flag === 1 ||
      data.partner_company_display_flag === 1 ||
      data.specifying_period_display_flag === 1 ||
      data.time_zone_display_flag === 1 ||
      data.machinery_type_display_flag === 1 ||
      data.partner_company_1_display_flag === 1 ||
      data.key_plan_reflect_display_flag === 1 
    );
  }

  outputSetting(reportSetting) {
    const fieldId = this.state.fieldId;
    const param = {
      field_id: fieldId,
      report_code: reportSetting.report_code,
      field_tree_users_limit: 1, // 初期表示に使用しないため
      field_tree_users_offset: 0,
      field_trees_limit: 1, // 初期表示に使用しないため
      field_trees_offset: 0,
    };
    ReportSettingService.outputSetting(param).then(resp => {
      if (resp.result) {
        const data = resp.data.entities.output_setting.report_setting;
        let hasFilter = 0;
        if (this.checkFilter(data)) {
          hasFilter = 1;
        }
        const settingParam = _.extend(
          {
            report_code:
              resp.data.entities.output_setting.report_setting.report_code,
          },
          this.defaultSettingParam
        );
        if (reportSetting.report_code === '51') {
          if (isPrimaryCompanyRoleId(parseInt(this.state.roleId))) {
            settingParam.is_partnerLv1_print = 1;
          }
          settingParam.approval_flag = 1;
        }
        if (
          reportSetting.report_code === '51' ||
          reportSetting.report_code === '52'
        ) {
          let fieldStartDay = this.state.fieldStartDay;
          settingParam.start_date = this.setDefaultStartDate(fieldStartDay);
          settingParam.end_date = this.setEndDateBasedStartDate(
            settingParam.start_date,
            fieldStartDay
          );
        }
        this.setState({
          hasFilter,
          settingId: reportSetting.id,
          settingReportName: reportSetting.report_name,
          outputSetting: resp.data.entities.output_setting,
          settingParam,
          errors: {},
        });
      }
    });

    if (reportSetting.report_code === '51') {
      FieldApprovalsService.getShortName(this.state.fieldId)
        .then(resp => {
          this.setState({
            fieldApprovalShortName: `${
              resp.data.entities.field_approval.short_name
            }未承認含む`,
          });
        })
        .catch(error => {
          alert(error);
        });
    }
  }

  changeUnitCode() {
    let unitCode = this.state.unitCode;
    if (unitCode === 1) {
      unitCode = 2;
    } else {
      unitCode = 1;
    }
    // 日付変更でリロードされた場合に保持するためにSessionStorageに保存
    SessionStorageService.setReportUnitCode(unitCode);
    this.setReportSettings(unitCode);
    this.setState({
      unitCode,
    });
  }

  checkStartAndEndDates() {
    const settingParam = _.cloneDeep(this.state.settingParam);
    const errors = _.cloneDeep(this.state.errors);
    let reportSetting = this.state.outputSetting.report_setting;
    let startDate = settingParam['start_date'];
    let endDate = settingParam['end_date'];
    if (startDate) {
      if (!moment(startDate, 'YYYY/M/D', true).isValid()) {
        startDate = moment().format('YYYY/MM/DD');
      } else {
        startDate = moment(startDate).format('YYYY/MM/DD');
      }
      settingParam['start_date'] = startDate;
    }
    if (
      reportSetting.specifying_period_display_flag &&
      (reportSetting.report_code === '51' || reportSetting.report_code === '52')
    ) {
      errors['DatePeriod'] =
        startDate === '' ? messageUtility.getMessage('E-000-010') : null;
      settingParam['end_date'] = this.setEndDateBasedStartDate(
        startDate,
        this.state.fieldStartDay
      );
    } else {
      if (endDate) {
        if (!moment(endDate, 'YYYY/M/D', true).isValid()) {
          endDate = moment().format('YYYY/MM/DD');
        } else {
          endDate = moment(endDate).format('YYYY/MM/DD');
        }
        settingParam['end_date'] = endDate;
      }
      if (moment(startDate).isAfter(endDate)) {
        errors['DatePeriod'] = messageUtility.getMessage('E-000-039');
      } else if (startDate === '' || endDate === '') {
        errors['DatePeriod'] = messageUtility.getMessage('E-001-359');
      } else if (
        moment(startDate)
          .add(6, 'days')
          .isBefore(endDate) &&
        WEEK_INTERVAL_REPORT_IDS.includes(reportSetting.id)
      ) {
        errors['DatePeriod'] = messageUtility.getMessage('E-001-361');
      } else {
        errors['DatePeriod'] = null;
      }
    }
    this.setState({
      settingParam,
      errors,
    });
  }

  setParam(e) {
    const settingParam = this.state.settingParam;
    settingParam[e.target.name] = e.target.value;
    this.setState({
      settingParam,
    });
  }

  setEndDateBasedStartDate(startDate, fieldStartDay) {
    if (!startDate) {
      return '';
    }
    let date = startDate.split('/');
    let year = parseInt(date[0]);
    let month = parseInt(date[1]);
    let startDay = parseInt(date[2]);
    if (!this.isValidDate(year, month, startDay)) {
      return '';
    }
    let endDay = 31;
    if (startDay > 1) {
      endDay =
        fieldStartDay > startDay && !this.isValidDate(year, month, startDay + 1)
          ? fieldStartDay
          : startDay;
      if (month === 12) {
        month = 1;
        year++;
      } else {
        month++;
      }
      return this.setFormatDate(year, month, endDay, false);
    }
    return this.setFormatDate(year, month, endDay, true);
  }

  isValidDate(year, month, day) {
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      return false;
    }
    let date = `${year}/${month}/${day}`;
    return moment(date, 'YYYY/M/D', true).isValid();
  }

  setDefaultStartDate(fieldStartDay) {
    let currentDate = new Date();
    let year = parseInt(currentDate.getFullYear());
    let month = parseInt(currentDate.getMonth()) + 1;
    if (fieldStartDay > currentDate.getDate()) {
      if (month === 1) {
        month = 12;
        year--;
      } else {
        month--;
      }
    }
    return this.setFormatDate(year, month, fieldStartDay, true);
  }

  setFormatDate(year, month, day, isFirstDay) {
    let flagDate = false;
    while (!flagDate) {
      flagDate = this.isValidDate(year, month, day);
      if (!flagDate) {
        day--;
      }
      if (day < 0) {
        return '';
      }
    }
    if (!isFirstDay) {
      day--;
    }
    if (day < 10) {
      day = `0${day}`;
    }
    if (month < 10) {
      month = `0${month}`;
    }
    return [year, month, day].join('/');
  }

  setCheckParam(e) {
    const settingParam = this.state.settingParam;
    if (settingParam[e.target.name] === 1) {
      settingParam[e.target.name] = 0;
    } else {
      settingParam[e.target.name] = 1;
    }
    this.setState({
      settingParam,
    });
  }

  setRadioParam(e, value) {
    const settingParam = this.state.settingParam;
    settingParam[e.target.name] = value;
    this.setState({
      settingParam,
    });
  }

  setDropdown(name, value) {
    const settingParam = this.state.settingParam;
    settingParam[name] = value;
    this.setState({
      settingParam,
    });
  }

  setForemanDropdown = (name, value) => {
    this.setDropdown(name, value);
    const settingParam = this.state.settingParam;
    if (settingParam.report_code !== '51') {
      if (value && (settingParam.start_date || settingParam.end_date)) {
        this.checkStartAndEndDates();
      } else {
        const errors = _.cloneDeep(this.state.errors);
        errors.DatePeriod = null;
        this.setState({ errors });
      }
    }
  };

  clearParam() {
    const settingParam = _.extend(
      {
        report_code: this.state.settingParam.report_code,
        resize_image_flag: this.state.settingParam.resize_image_flag,
      },
      this.defaultSettingParam
    );
    this.setState({
      settingParam,
      errors: {},
    });
  }

  getPrintParam() {
    return {
      field_id: sessionStorage.getItem('field_id'),
      target_date: sessionStorage.getItem('date_from'),
      work_hour_zone: sessionStorage.getItem('work_hour_zone'),
    };
  }

  makeReportFileName(prefix) {
    const reportName = this.state.settingReportName;
    const timestamp = moment().format('YYYYMMDDHHmmss');
    return `${reportName}_${timestamp}.${prefix}`;
  }

  // レポート名_YYYYMMDDHHmm.xlsx
  outputExcel() {
    if (this.excelOutput) {
      return;
    }
    let param = _.cloneDeep(this.state.settingParam);
    // エラーチェック
    if (this.checkValidate(param)) {
      return;
    }
    this.excelOutput = true;
    param.field_id = this.state.fieldId;
    param.work_hour_zone = this.state.workHourZone;
    param.target_date = this.state.targetDate;
    param.file_code = FILE_CODE.EXCEL;
    if (
      RoleUtility.hasRole(parseInt(this.state.roleId), [
        USER_ROLES.foreman,
        USER_ROLES.partner,
      ])
    ) {
      if (this.state.outputSetting.report_setting.report_code === '51') {
        if (param.foreman_user_id) {
          param.is_foreman_print = 1;
        } else {
          param.foreman_user_id = localStorage.getItem('user_id');
          param.is_foreman_print = 2;
        }
      } else {
        param.foreman_user_id = localStorage.getItem('user_id');
        param.is_foreman_print = 1;
      }
    }
    if (
      this.state.outputSetting.report_setting
        .partner_company_1_unit_display_flag === 1
    ) {
      if (param.is_partnerLv1_print === 1) {
        delete param.foreman_user_id;
      } else {
        delete param.field_tree_id;
      }
    }
    let reportSetting = this.state.outputSetting.report_setting;
    if (
      param.report_code !== '51' &&
      param.report_code !== '52' &&
      reportSetting.specifying_period_display_flag &&
      !param.foreman_user_id
    ) {
      delete param.start_date;
      delete param.end_date;
    }
    const targetReport = _.find(
      ReportLists,
      report => this.state.settingId === report.id
    );
    if (targetReport) {
      return PrintService.printReportByReportName(
        targetReport.name,
        param,
        this.state.hasFilter
      )
        .then(async blob => {
          this.excelOutput = false;
          // 1週間を超える期間指定が設定された場合、エラーダイアログを表示
          const response = await blobToJsonConversion(blob);
          if (_.isUndefined(response.message)) {
            const fileName = PrintService.makeReportFileName(
              targetReport.name,
              param.file_code,
              param.target_date
            );
            PrintUtility.printBlob(blob, fileName);
          } else {
            this.handleVisibleDialog(response.message);
          }
        })
        .catch(() => {
          this.excelOutput = false;
        });
    } else {
      PrintService.output(param).then(response => {
        this.excelOutput = false;
        if (response === undefined) {
          return;
        }
        const filename = this.makeReportFileName('xlsx');
        if (window.navigator.msSaveBlob) {
          window.navigator.msSaveOrOpenBlob(response, filename);
        } else {
          const fileUrl = URL.createObjectURL(response);
          const link = document.createElement('a');
          link.download = filename;
          link.href = fileUrl;
          link.click();
        }
      });
    }
  }

  // レポート名_YYYYMMDDHHmm.xlsx
  outputPdf() {
    if (this.pdfOutput) {
      return;
    }
    let param = _.cloneDeep(this.state.settingParam);
    // エラーチェック
    if (this.checkValidate(param)) {
      return;
    }
    this.pdfOutput = true;
    param.field_id = this.state.fieldId;
    param.work_hour_zone = this.state.workHourZone;
    param.target_date = this.state.targetDate;
    param.file_code = FILE_CODE.PDF;
    if (
      RoleUtility.hasRole(parseInt(this.state.roleId), [
        USER_ROLES.foreman,
        USER_ROLES.partner,
      ])
    ) {
      if (this.state.outputSetting.report_setting.report_code === '51') {
        if (param.foreman_user_id) {
          param.is_foreman_print = 1;
        } else {
          param.foreman_user_id = localStorage.getItem('user_id');
          param.is_foreman_print = 2;
        }
      } else {
        param.foreman_user_id = localStorage.getItem('user_id');
        param.is_foreman_print = 1;
      }
    }
    if (
      this.state.outputSetting.report_setting
        .partner_company_1_unit_display_flag === 1
    ) {
      if (param.is_partnerLv1_print === 1) {
        delete param.foreman_user_id;
      } else {
        delete param.field_tree_id;
      }
    }
    let reportSetting = this.state.outputSetting.report_setting;
    if (
      param.report_code !== '51' &&
      param.report_code !== '52' &&
      reportSetting.specifying_period_display_flag &&
      !param.foreman_user_id
    ) {
      delete param.start_date;
      delete param.end_date;
    }
    const targetReport = _.find(
      ReportLists,
      report => this.state.settingId === report.id
    );
    if (targetReport) {
      const newTab = window.open('/LayoutPrint', '_blank');
      return PrintService.printReportByReportName(
        targetReport.name,
        param,
        this.state.hasFilter
      )
        .then(response => {
          this.pdfOutput = false;
          if (_.isUndefined(response.message)) {
            const pdfUrl = response.pdf_s3_url;
            PrintService.getHeaderReponseURL(pdfUrl.head_pdf_url)
              .then(responseS3AWS => {
                if (responseS3AWS.status === STATUS_CODE.ok) {
                  const fileName = PrintService.makeReportFileName(
                    targetReport.name,
                    param.file_code,
                    param.target_date
                  );
                  const blob = PrintUtility.convertBase64ToBlob(
                    response.data,
                    'application/pdf'
                  );
                  PrintUtility.printBlob(blob, fileName, param.file_code);
                  newTab.location.href = pdfUrl.get_pdf_url;
                }
              })
              .catch(() => {
                newTab.close();
                this.handleVisibleDialog(
                  messageUtility.getMessage('E-001-401')
                );
              });
          } else {
            newTab.close();
            this.handleVisibleDialog(response.message);
          }
        })
        .catch(() => {
          newTab.close();
          this.pdfOutput = false;
        });
    } else {
      let pdfWindow = '';
      if (!window.navigator.msSaveBlob) {
        pdfWindow = window.open('', '_blank');
      }
      PrintService.output(param).then(response => {
        this.pdfOutput = false;
        if (response === undefined) {
          return;
        }
        if (window.navigator.msSaveBlob) {
          const fileName = this.makeReportFileName('pdf');
          window.navigator.msSaveOrOpenBlob(response, fileName);
        } else {
          const fileUrl = URL.createObjectURL(response);
          pdfWindow.location = fileUrl;
        }
      });
    }
  }

  /**
   *  checkValidate
   */
  checkValidate(param) {
    const errors = _.cloneDeep(this.state.errors);
    if (
      (param.report_code === '51' || param.report_code === '52') &&
      param.start_date === ''
    ) {
      errors['DatePeriod'] = messageUtility.getMessage('E-000-010');
      this.setState({ errors });
      return true;
    } else if ('DatePeriod' in errors && !!errors['DatePeriod']) {
      return true;
    }
    errors['DatePeriod'] = null;
    this.setState({ errors });
    return false;
  }

  getItemListTitle() {
    FieldItemInputService.itemNames(this.state.fieldId).then(itemNames =>
      this.setState({ itemNames })
    );
  }

  /**
   * @description ダイアログ開閉設定
   * @param {string} apiMessage APIレスポンスメッセージ
   */
  handleVisibleDialog(apiMessage = null) {
    this.setState({
      visibleDialogFlag: !this.state.visibleDialogFlag,
      apiMessage,
    });
  }

  render() {
    const MainHeader = ({ unitCode }) => {
      if (!this.isEnableMonthlyReport) {
        return <ConferencePageHeader title='日次帳票印刷' />;
      } else {
        return (
          <ConferencePageHeader
            title={unitCode === 1 ? '日次帳票印刷' : '月次帳票印刷'}
            leftComponent={
              <button
                className='btn--stay'
                onClick={() => this.events.header.changeUnitCode()}
              >
                {unitCode === 1 ? '月次帳票を表示する' : '日次帳票を表示する'}
              </button>
            }
          />
        );
      }
    };

    return (
      <div id='main' className='main'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.conference} -
            {this.state.unitCode === 1
              ? ' 帳票印刷（日次）'
              : ' 帳票印刷（月次）'}
          </title>
        </Helmet>
        <MainHeader unitCode={this.state.unitCode} />
        <div className='main__body' style={{ overflow: 'hidden' }}>
          <div className='container' style={{ minWidth: '859px' }}>
            <div
              className='container__list --col-xl-4 --col-md-2 --col-xs-4'
              style={{ minWidth: '350px' }}
            >
              <div className='document-print-list'>
                <ul className='list list--document-print-list'>
                  {this.state.reportSettings.map((reportSetting, index) => {
                    return (
                      <li
                        key={index}
                        className={`line-list ${
                          reportSetting.id === this.state.settingId
                            ? 'select'
                            : ''
                        }`}
                        onClick={() =>
                          this.events.sidebar.outputSetting(reportSetting)
                        }
                        style={{ fontSize: '14px' }}
                      >
                        {/* divがないとtext-indentが効かなくなる場合がある */}
                        <div>{reportSetting.report_name}</div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <OutputSettingContents
              role={this.state.roleId}
              settingId={this.state.settingId}
              outputSetting={this.state.outputSetting}
              settingParam={this.state.settingParam}
              callback={this.events}
              itemNames={this.state.itemNames}
              workHourZone={this.state.workHourZone}
              fieldApprovalShortName={this.state.fieldApprovalShortName}
              fieldId={this.state.fieldId}
              machineryTypesReport={this.state.machineryTypesReport}
              errors={this.state.errors}
            />
          </div>
        </div>
        <Information
          visible={this.state.visibleDialogFlag}
          message={this.state.apiMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.handleVisibleDialog()}
          buttonClassName='btn--sm--sub'
        />
      </div>
    );
  }
}

const OutputSettingContents = ({
  role,
  settingId,
  outputSetting,
  settingParam,
  callback,
  itemNames,
  workHourZone,
  fieldApprovalShortName,
  fieldId,
  machineryTypesReport,
  errors,
}) => {
  if (settingId == null) {
    return null;
  }
  // if (!settingParam.field_tree_id && settingId === 30) {
  //   settingParam.field_tree_id = outputSetting.field_trees[0]['id'];
  // }
  const optionDisplayFlags = ReportDisplayOptions.getDisplayFlagsByConditions(
    outputSetting.report_setting.report_code,
    role
  );

  const reportSetting = {
    ...outputSetting.report_setting,
    ...optionDisplayFlags,
  };

  const SelectFieldItemList1 = () => {
    return (
      <SettingSelect
        label={itemNames.A}
        dropdownDefault={`${itemNames.A}を選択`}
        name='a_item_id'
        list={outputSetting.a_items}
        idName='id'
        valName='name'
        value={settingParam.a_item_id}
        changeEvent={callback.setting.setDropdown.bind(this)}
        isOptional={true}
      />
    );
  };

  const SelectFieldItemList2 = () => {
    return (
      <SettingSelect
        label={itemNames.B}
        dropdownDefault={`${itemNames.B}を選択`}
        name='b_item_id'
        list={outputSetting.b_items}
        idName='id'
        valName='name'
        value={settingParam.b_item_id}
        changeEvent={callback.setting.setDropdown.bind(this)}
        isOptional={true}
      />
    );
  };

  const SelectFieldItemList3 = () => {
    return (
      <SettingSelect
        label={itemNames.C}
        dropdownDefault={`${itemNames.C}を選択`}
        name='c_item_id'
        list={outputSetting.c_items}
        idName='id'
        valName='name'
        value={settingParam.c_item_id}
        changeEvent={callback.setting.setDropdown.bind(this)}
        isOptional={true}
      />
    );
  };

  const SelectFieldItemList4 = () => {
    return (
      <SettingSelect
        label={itemNames.D}
        dropdownDefault={`${itemNames.D}を選択`}
        name='d_item_id'
        list={outputSetting.d_items}
        idName='id'
        valName='name'
        value={settingParam.d_item_id}
        changeEvent={callback.setting.setDropdown.bind(this)}
        isOptional={true}
      />
    );
  };

  const SelectPartnerCompany = () => {
    return (
      <li id='field_tree_id' className='form-list__item'>
        <div className='form-list__labels'>
          <span className='label'>協力会社</span>
        </div>
        <div className='form-list__element'>
          <DropdownSelector
            className='--col-xs-12 --col-md-6 --col-lg-8 --col-xl-8'
            label='全協力会社一括'
            selectorName='field_tree_id'
            api={params =>
              ReportSettingService.outputSetting(
                _.omit(
                  _.assign(params, {
                    field_tree_users_limit: REQUEST_PARAMS.parentLimit,
                    field_tree_users_offset: 0,
                    field_trees_limit: params.limit,
                    field_trees_offset: params.offset,
                  }),
                  ['limit', 'offset', 'is_limit']
                )
              )
            }
            limit={REQUEST_PARAMS.parentLimit}
            apiParams={{
              field_id: fieldId,
              report_code: outputSetting.report_setting.report_code,
            }}
            apiSearchKey='full_company_name'
            selectedValues={
              settingParam.field_tree_id ? [settingParam.field_tree_id] : []
            }
            keyName='full_company_name'
            apiProcess={response => {
              const list = _.map(
                response.data.entities.output_setting.field_trees,
                item => ({
                  id: item.id,
                  full_company_name: item.full_company_name,
                })
              );
              return {
                data: list,
                total: list.length,
              };
            }}
            onSelect={callback.setting.setDropdown}
            exceptionAllLoadedLimit={true}
            isOptional={true}
          />
          <div style={{ height: '46px' }} />
        </div>
      </li>
    );
  };

  const SelectPartnerCompanyLevel1 = () => {
    return (
      <SettingSelect
        label='１次協力会社'
        dropdownDefault='１次協力会社を選択'
        name='field_tree_id'
        list={outputSetting.field_trees_level1}
        idName='id'
        valName='company_name'
        value={settingParam.field_tree_id}
        changeEvent={callback.setting.setDropdown.bind(this)}
      />
    );
  };

  const SelectForemanUser = () => {
    return (
      <li id='foreman_user_id' className='form-list__item'>
        <div className='form-list__labels'>
          <span className='label'>職長</span>
        </div>
        <div className='form-list__element'>
          <DropdownSelector
            className='--col-xs-12 --col-md-6 --col-lg-8 --col-xl-8'
            label='職長を選択'
            selectorName='foreman_user_id'
            api={params =>
              ReportSettingService.outputSetting(
                _.omit(
                  _.assign(params, {
                    field_tree_users_limit: params.limit,
                    field_tree_users_offset: params.offset,
                    field_trees_limit: REQUEST_PARAMS.parentLimit,
                    field_trees_offset: 0,
                  }),
                  ['limit', 'offset', 'is_limit']
                )
              )
            }
            limit={REQUEST_PARAMS.parentLimit}
            apiParams={{
              field_id: fieldId,
              report_code: outputSetting.report_setting.report_code,
            }}
            apiSearchKey='full_foreman_user_name'
            selectedValues={
              settingParam.foreman_user_id ? [settingParam.foreman_user_id] : []
            }
            keyName='full_foreman_user_name'
            apiProcess={response => {
              const list = _.map(
                response.data.entities.output_setting.field_tree_users,
                item => ({
                  id: item.id,
                  full_foreman_user_name: item.full_foreman_user_name,
                })
              );
              return {
                data: list,
                total: list.length,
              };
            }}
            onSelect={callback.setting.setForemanDropdown}
            isOptional={true}
          />
          <div style={{ height: '46px' }} />
        </div>
      </li>
    );
  };

  const SelectKeyplan = () => {
    return (
      <SettingSelect
        label='キープラン'
        dropdownDefault='キープランを選択'
        name='category_code'
        list={outputSetting.field_images}
        idName='category_code'
        valName='comment'
        value={settingParam.category_code}
        changeEvent={callback.setting.setDropdown.bind(this)}
        isOptional={true}
      />
    );
  };

  const SelectGate = () => {
    return (
      <SettingSelect
        label='ゲート'
        dropdownDefault='ゲートを選択'
        name='gate_id'
        list={outputSetting.gates}
        idName='id'
        valName='name'
        value={settingParam.gate_id}
        changeEvent={callback.setting.setDropdown.bind(this)}
        isOptional={true}
      />
    );
  };

  const SelectCrane = () => {
    return (
      <SettingSelect
        label='クレーン'
        dropdownDefault='クレーンを選択'
        name='crane_id'
        list={outputSetting.cranes}
        idName='id'
        valName='name'
        value={settingParam.crane_id}
        changeEvent={callback.setting.setDropdown.bind(this)}
        isOptional={true}
      />
    );
  };

  // eslint-disable-next-line no-unused-vars
  const SelectMachinery = () => {
    return (
      <SettingSelect
        label='機材'
        dropdownDefault='機材を選択'
        name='machinery_id'
        list={outputSetting.machineries}
        idName='id'
        valName='name'
        value={settingParam.machinery_id}
        changeEvent={callback.setting.setDropdown.bind(this)}
        isOptional={true}
      />
    );
  };

  const SelectMachineryType = () => {
    return (
      <SettingSelect
        label='機材種別'
        dropdownDefault='機材種別を選択'
        name='machinery_type'
        list={machineryTypesReport}
        idName='id'
        valName='name'
        value={settingParam.machinery_type}
        changeEvent={callback.setting.setDropdown.bind(this)}
        isOptional={true}
      />
    );
  };

  const SelectTimeZone = () => {
    const zone = _.find(WORK_HOUR_ZONES, {
      id: _.parseInt(workHourZone),
    });
    const zoneLabel = `${zone.name}間作業のみ`;
    return (
      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>作業時間帯</span>
        </div>
        <div className='form-list__element'>
          <div className='work-times'>
            <label htmlFor='time_zone-1' className='radio'>
              <input
                type='radio'
                id='time_zone-1'
                name='time_zone'
                readOnly
                checked={
                  settingParam.time_zone === REPORT_WORK_HOUR_ZONE.specific.id
                }
                onClick={e =>
                  callback.setting.setRadioParam(
                    e,
                    REPORT_WORK_HOUR_ZONE.specific.id
                  )
                }
              />
              <i className='i-circle i-3x' aria-hidden='true' />
              {zoneLabel}
            </label>
            <label htmlFor='time_zone-2' className='radio'>
              <input
                type='radio'
                id='time_zone-2'
                name='time_zone'
                readOnly
                checked={
                  settingParam.time_zone === REPORT_WORK_HOUR_ZONE.all.id
                }
                onClick={e =>
                  callback.setting.setRadioParam(
                    e,
                    REPORT_WORK_HOUR_ZONE.all.id
                  )
                }
              />
              <i className='i-circle i-3x' aria-hidden='true' />
              全時間帯の作業
            </label>
          </div>
        </div>
      </li>
    );
  };

  const SelectKeyPlanReflect = () => {
    return (
      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>キープラン反映有無</span>
        </div>
        <div className='form-list__element'>
          <div className='element__item'>
            <label htmlFor='key_plan_reflect_flag_check' className='radio'>
              <input
                type='radio'
                id='key_plan_reflect_flag_check'
                name='key_plan_reflect_flag'
                readOnly
                checked={
                  settingParam.key_plan_reflect_flag === REPORT_KEY_PLAN_REFLECT_FLAG.reflect.id
                }
                onClick={e =>
                  callback.setting.setRadioParam(
                    e,
                    REPORT_KEY_PLAN_REFLECT_FLAG.reflect.id
                  )
                }
              />
              <i className='i-circle i-3x' aria-hidden='true' />
              反映する
            </label>
            <label htmlFor='key_plan_reflect_flag_uncheck' className='radio'>
              <input
                type='radio'
                id='key_plan_reflect_flag_uncheck'
                name='key_plan_reflect_flag'
                readOnly
                checked={
                  settingParam.key_plan_reflect_flag === REPORT_KEY_PLAN_REFLECT_FLAG.not_reflect.id
                }
                onClick={e =>
                  callback.setting.setRadioParam(
                    e,
                    REPORT_KEY_PLAN_REFLECT_FLAG.not_reflect.id
                  )
                }
              />
              <i className='i-circle i-3x' aria-hidden='true' />
              反映しない
            </label>
          </div>
        </div>
      </li>
    );
  };

  const SelectApprovalFlag = () => {
    return (
      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>{fieldApprovalShortName}</span>
        </div>
        <div className='form-list__element'>
          <label htmlFor='approval_flag' className='checkbox'>
            <input
              type='checkbox'
              id='approval_flag'
              name='approval_flag'
              readOnly
              checked={settingParam.approval_flag === 1}
              onChange={e => callback.setting.setCheckParam(e)}
            />
            <i className='i-square i-3x' aria-hidden='true' />
          </label>
        </div>
      </li>
    );
  };

  const SelectPartnerCompany1Unit = () => {
    return (
      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>１次協力会社単位に出力</span>
        </div>
        <div className='form-list__element'>
          <label htmlFor='is_partnerLv1_print' className='checkbox'>
            <input
              type='checkbox'
              id='is_partnerLv1_print'
              name='is_partnerLv1_print'
              readOnly
              checked={settingParam.is_partnerLv1_print === 1}
              onChange={e => callback.setting.setCheckParam(e)}
            />
            <i className='i-square i-3x' aria-hidden='true' />
          </label>
        </div>
      </li>
    );
  };

  const SelectResizeImange = () => {
    return (
      <li className='form-list__item'>
        <div className='form-list__element'>
          <label htmlFor='resize_image_flag' className='checkbox'>
            <input
              className='form-list__element-resize-box'
              id='resize_image_flag'
              name='resize_image_flag'
              type='checkbox'
              checked={settingParam.resize_image_flag === CHECKBOX.On}
              onClick={e => callback.setting.setCheckParam(e)}
            />
            <i className='i-square i-3x' />
            <span>解像度を下げて印刷</span>
          </label>
        </div>
      </li>
    );
  };

  const SpecifyingPeriod = () => {
    let startDateDisabled = false;
    let endDateDisabled = false;
    let btnSpinStyle = {};
    if (
      reportSetting.report_code === '51' ||
      reportSetting.report_code === '52'
    ) {
      endDateDisabled = true;
      btnSpinStyle = { display: 'none' };
    } else {
      startDateDisabled = settingParam.foreman_user_id ? false : true;
      endDateDisabled = settingParam.foreman_user_id ? false : true;
    }
    if (startDateDisabled === true || endDateDisabled === true) {
      btnSpinStyle = { display: 'none' };
    }
    return (
      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>期間指定</span>
        </div>
        <div className='form-list__element'>
          <div className='form-element-horizontal'>
            <div className='form-element-horizontal__item  sys-form-calender'>
              <div
                id='groundbreaking-date-calender-popup'
                className='dropdown-calender'
              >
                <div className='dropdown-calender__input'>
                  <input
                    disabled={startDateDisabled}
                    id='groundbreaking-date'
                    className='sys-dropdown-trigger sys-name --col-xl-2 --col-lg-2 --col-md-3 --col-xs-3'
                    type='text'
                    name='start_date'
                    placeholder='(例)2020/01/01'
                    value={settingParam.start_date}
                    onChange={e => callback.setting.setParam(e)}
                    onBlur={() => callback.setting.checkStartAndEndDates()}
                    autoComplete='off'
                  />
                  <div className='btn-spin' style={btnSpinStyle}>
                    <button className='btn-spin__up sys-calender-day-up'>
                      <i className='i_arrow-top' />
                    </button>
                    <button className='btn-spin__down sys-calender-day-down'>
                      <i className='i_arrow-bottom' />
                    </button>
                  </div>
                </div>
                <div className='dropdown'>
                  <div className='dropdown-calender__calender' />
                </div>
              </div>
            </div>
            <div className='form-element-horizontal__item'>-</div>
            <div className='form-element-horizontal__item sys-form-calender'>
              <div
                id='groundbreaking-date-calender-popup'
                className='dropdown-calender'
              >
                <div className='dropdown-calender__input'>
                  <input
                    disabled={endDateDisabled}
                    id='groundbreaking-date'
                    className='sys-dropdown-trigger sys-name --col-xl-2 --col-lg-2 --col-md-3 --col-xs-3'
                    type='text'
                    name='end_date'
                    placeholder='(例)2020/01/01'
                    value={settingParam.end_date}
                    onChange={e => callback.setting.setParam(e)}
                    onBlur={() => callback.setting.checkStartAndEndDates()}
                    autoComplete='off'
                  />
                  <div className='btn-spin' style={btnSpinStyle}>
                    <button className='btn-spin__up sys-calender-day-up'>
                      <i className='i_arrow-top' />
                    </button>
                    <button className='btn-spin__down sys-calender-day-down'>
                      <i className='i_arrow-bottom' />
                    </button>
                  </div>
                </div>
                <div className='dropdown'>
                  <div className='dropdown-calender__calender' />
                </div>
              </div>
            </div>
          </div>
          {!errors.DatePeriod &&
            (settingParam.start_date === '' || settingParam.end_date === '') &&
            settingParam.foreman_user_id &&
            WEEK_INTERVAL_REPORT_IDS.includes(settingId) && (
              <div className='form-list__alert show'>
                {messageUtility.getMessage('E-001-360')}
              </div>
            )}
          <div className='form-list__alert show'>{errors.DatePeriod}</div>
        </div>
      </li>
    );
  };
  const settingFieldGroup = () => {
    return (
      <li id='field_group_ids' className='form-list__item'>
        <div className='form-list__labels'>
          <span className='label'>グループ</span>
        </div>
        <div className='form-list__element'>
          <DropdownSelector
            className='--col-xs-12 --col-md-6 --col-lg-8 --col-xl-8'
            label='選択してください'
            multiple={true}
            selectorName='field_group_ids'
            apiParams={{
              limit: REQUEST_PARAMS.parentLimit,
            }}
            api={params =>
              FieldGroupService.listForSearch(fieldId, params)
            }
            apiSearchKey='name'
            keyName='name'
            valueName='id'
            apiBindDataKey='field_groups'
            selectedValues={settingParam.field_group_ids}
            onSelect={callback.setting.setDropdown}
          />
        </div>
      </li>
    );
  }

  const settingList = [
    reportSetting.field_item_list1_display_flag ? SelectFieldItemList1() : null,
    reportSetting.field_item_list2_display_flag ? SelectFieldItemList2() : null,
    reportSetting.field_item_list3_display_flag ? SelectFieldItemList3() : null,
    reportSetting.field_item_list4_display_flag ? SelectFieldItemList4() : null,
    reportSetting.partner_company_display_flag ? SelectPartnerCompany() : null,
    reportSetting.foreman_user_display_flag &&
    settingParam.is_partnerLv1_print !== 1
      ? SelectForemanUser()
      : null,
    ((reportSetting.partner_company_1_unit_display_flag && settingParam.is_partnerLv1_print === 1) 
    || reportSetting.partner_company_1_display_flag)
      ? SelectPartnerCompanyLevel1()
      : null,
    reportSetting.key_plan_display_flag ? SelectKeyplan() : null,
    reportSetting.gate_display_flag ? SelectGate() : null,
    reportSetting.crane_display_flag ? SelectCrane() : null,
    reportSetting.machinery_type_display_flag ? SelectMachineryType() : null,
    reportSetting.machinery_display_flag ? SelectMachinery() : null,
    reportSetting.time_zone_display_flag ? SelectTimeZone() : null,
    reportSetting.report_code === '51' ? SelectApprovalFlag() : null,
    reportSetting.partner_company_1_unit_display_flag
      ? SelectPartnerCompany1Unit()
      : null,
    reportSetting.field_group_display_flag ? settingFieldGroup() : null,
    reportSetting.key_plan_reflect_display_flag ? SelectKeyPlanReflect() : null,
    reportSetting.specifying_period_display_flag ? SpecifyingPeriod() : null
  ];
  const targetReport = _.find(
    ReportLists,
    report => report.hideExcelButtonForPartner && report.id === settingId
  );
  const excelDisplayFlag =
    !targetReport || isPrimaryCompanyRoleId(role) ? true : false;
  
  // List of report codes that should hide the top red text
  const reportCodeHideTopRedText = [ /*CR838*/196, /*CR839*/197 ];

  return (
    <div
      className='container__col --col-xl-8 --col-md-10 --col-xs-8'
      style={{ maxWidth: '570px', flex: 1 }}
    >
      {!reportCodeHideTopRedText.includes(Number(reportSetting.report_code)) ? (
        <div
          style={{ height: 'auto', marginBottom: 20, lineHeight: 1.5 }}
          className='form-list__header-alert show'
        >
          画面上部のカレンダーで「期間」を選択しても、指定期間分の帳票は出力されません。
          「期間」を選択した場合は、指定期間の開始日の帳票のみが出力されますのでご注意ください。
        </div> 
      ) : null}
      <ul className='form-list'>
        <ul className='btn-menu' style={{ marginBottom: 30 }}>
          {reportSetting.printout_excel_flag === API_FLAG.On &&
          excelDisplayFlag ? (
            <li className='btn-menu__item'>
              <button
                className='btn--sub'
                onClick={() => callback.setting.outputExcel()}
              >
                Excelで出力
              </button>
            </li>
          ) : null}
          {reportSetting.printout_pdf_flag === 1 ? (
            <li className='btn-menu__item'>
              <button
                className='btn--sub'
                onClick={() => callback.setting.outputPdf()}
              >
                PDFで出力
              </button>
            </li>
          ) : null}
        </ul>
        {reportSetting.resize_image_flag ? SelectResizeImange() : null}
        <li className='form-list__item'>
          {!_.isEmpty(
            _.filter(settingList, item => {
              return item !== null;
            })
          ) ? (
            <div className='search-form__header'>
              <div className='search-form__title'>絞り込み条件</div>
              <button
                className='btn-text--sm'
                onClick={() => callback.setting.clearParam()}
              >
                絞り込み条件クリア
              </button>
            </div>
          ) : null}
        </li>
        {settingList.map((setting, index) => {
          if (setting) {
            return <div key={index}>{setting}</div>;
          }
        })}
      </ul>
    </div>
  );
};

class SettingSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showForm: false,
      searchWord: '',
      list: this.props.list,
      selectId: this.props.value,
    };
    this.parent = React.createRef();

    this.onClickItem = this.onClickItem.bind(this);
    this.clearSelectedRow = this.clearSelectedRow.bind(this);
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(props, state) {
    if (this.state.showForm) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!this.state.showForm) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ showForm: false });
  };

  handleShowForm() {
    if (!this.state.showForm) {
      this.setState({
        selectId: this.props.value,
      });
    }
    this.setState({
      showForm: !this.state.showForm,
    });
  }

  onChangeSearchWord(e) {
    this.updateList(e.target.value);
    this.setState({
      searchWord: e.target.value,
    });
  }

  updateList(searchWord) {
    let list = this.props.list;
    if (searchWord !== '') {
      list = _.filter(list, item => {
        return item[this.props.valName].indexOf(searchWord) >= 0;
      });
    }
    this.setState({
      selectId: null,
      list,
    });
  }

  onClickItem(item) {
    // console.log(item);
    const selectId = _.find(this.state.list, listItem => {
      return listItem[this.props.idName] === item;
    });
    this.setState({ selectId: selectId[this.props.idName] }, () => {
      this.onClickSelect();
    });
  }

  onClickSelect() {
    this.props.changeEvent(this.props.name, this.state.selectId);
    this.setState({
      showForm: false,
    });
  }

  clearSelectedRow() {
    this.setState({ selectId: '' }, () => {
      this.onClickSelect();
    });
  }

  render() {
    const getDropdownLabel = () => {
      let label = this.props.dropdownDefault;
      if (this.props.value !== '') {
        _.each(this.props.list, item => {
          if (item[this.props.idName] === this.props.value) {
            if (this.props.name === 'category_code') {
              label = `${item.key_plan_name} : ${item.comment}`;
            } else {
              label = item[this.props.valName];
            }
          }
        });
      }
      return label;
    };

    return (
      <li id={this.props.name} className='form-list__item'>
        <div className='form-list__labels'>
          <span className='label'>{this.props.label}</span>
        </div>
        <div className='form-list__element set-width-dropdown'>
          <div
            className='dropdown-single-select --col-xs-12 --col-md-6 --col-lg-8 --col-xl-8'
            ref={this.parent}
          >
            <div
              className='dropdown-single-select__header'
              onClick={() => this.handleShowForm()}
            >
              <div className='dropdown-select'>
                <span className='dropdown-select__txt'>
                  {getDropdownLabel()}
                </span>
              </div>
            </div>
            {this.state.showForm && (
              <div className={`dropdown dropdown--dropdown-list show`}>
                <div className='dropdown__item dropdown__item--hidden'>
                  <div className='dropdown-single-select__item'>
                    <i className='i-search i-2x' />
                    <input
                      type='text'
                      className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                      placeholder={messageUtility.getMessage('I-000-090')}
                      defaultValue={this.state.searchWord}
                      onChange={e => this.onChangeSearchWord(e)}
                    />
                  </div>
                  {this.props.isOptional && (
                    <div className='dropdown-single-select__item'>
                      <FormDropdownClearButton
                        onClick={this.clearSelectedRow}
                      />
                    </div>
                  )}
                  <div className='dropdown-single-select__item'>
                    <div className='dropdown-single-select__scroll'>
                      <ul className='single-select'>
                        {_.size(this.state.list) !== 0 ? (
                          <React.Fragment>
                            {this.state.list.map((item, index) => (
                              <FormDropdownRadio
                                key={index}
                                option={item}
                                checked={
                                  this.state.selectId ===
                                  item[this.props.idName]
                                }
                                targetId={this.id}
                                handleSelectedRow={this.onClickItem}
                                forId='setting-select'
                                column={this.props.idName}
                              >
                                {this.props.name === 'category_code'
                                  ? `${item.key_plan_name} : ${item.comment}`
                                  : item[this.props.valName]}
                              </FormDropdownRadio>
                            ))}
                          </React.Fragment>
                        ) : (
                          <div className='table-has-no-data'>
                            <div className='table-has-no-data__message'>
                              {messageUtility.getMessage('I-000-046')}
                            </div>
                          </div>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className='form-list__alert show'>
              {_.has(this.props, 'validate') ? this.props.validate : null}
            </div>
          </div>
        </div>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ReportSettings.jsx